import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Rapporte un évènement de progression de mission (fire-and-forget).
// Comptes connectés uniquement : le backend renvoie 401 pour les invités, ignoré silencieusement.
export const reportMissionEvent = (event, amount = 1) => {
  axios
    .post(`${API}/missions/event`, { event, amount }, { withCredentials: true })
    .catch(() => {});
};

export const fetchMissions = async () => {
  const res = await axios.get(`${API}/missions`, { withCredentials: true });
  return res.data;
};

export const claimMission = async (category, missionId) => {
  const res = await axios.post(
    `${API}/missions/claim`,
    { category, mission_id: missionId },
    { withCredentials: true }
  );
  return res.data;
};
